import {
	AlertController,
	IonicPage,
	Loading,
	LoadingController,
	NavController,
	NavParams,
	ToastController,
	ViewController
} from 'ionic-angular'
import { Component, ChangeDetectorRef } from '@angular/core'

import { AccountType, DeviceType } from '../../models/models'


import { AuthProvider } from '../../providers/auth/auth'
import { DeviceProvider } from '../../providers/device/device'
import { FlavourProvider } from '../../providers/flavour/flavour'

import { ConfigProvider } from '../../providers/config/config'
import { SignalingSocketIoProvider } from '../../providers/signaling/socket_io'


class Credentials {
	public identifier: string
	public secret: string
}

@IonicPage()
@Component({
	selector: 'page-login',
	templateUrl: 'login.html',
})
export class LoginPage {
	private popTimeout: number = null;
	/**
	Se true e non è presente next, dopo il login esegue un pop senza impostare la pagina
	*/
	nextPop: boolean
	//	@ViewChild(ClientApp) app: ClientApp;

	public remember: boolean = false;

	loading: Loading
	public credentials: Credentials = {
		identifier: '',
		secret: ''
	};

	public isExclusiveLogin: boolean

	/**
	Se true permette login solo col metodo specificato
	*/
	public isTypeForced: boolean = false;

	//public authHomePage:any=null;
	public next: any//Consente di sovrascrivere la pagina successiva al login quando ha successo
	public nextNavParams: any//Parametri per sovrascrivere la pagina successiva al login quando ha successo
	public nextCall: any//Se impostata, dopo il login invoca questa funzione

	/*
	Funzione da invocare se ok login, controlla che abbia i permessi
	*/
	public nextGuard: (auth: AuthProvider) => boolean
	/**
	Quando next è valorizzata, se true next va in push, altrimenti next diventa root
	*/
	public nextPush: boolean

	public roles: string[] = null;

	public type: AccountType

	public get digits() {
		return new Array(Math.max(this.credentials.identifier.length, 4))
	}

	/**
	Verifica se su questo dispositivo può memorizzare l'autenticazione utente
	*/
	public get isRememberable(): boolean {
		switch(this.devices.actualType) {
			case DeviceType.SMARTPHONE:
			case DeviceType.BROWSER:
				//console.debug('[LoginPage.isRememberable] Questo dispositivo consente di ricordare l\'utente autenticato', this.devices.actualType)
				return true
		}
		//console.debug('[LoginPage.isRememberable] Questo dispositivo non consente di ricordare l\'utente autenticato', this.devices.actualType)
		return false
	}

	constructor(
		private auth: AuthProvider,
		private alertCtrl: AlertController,
		private changeDetector: ChangeDetectorRef,
		private devices: DeviceProvider,
		private flavour: FlavourProvider,
		private loadingCtrl: LoadingController,
		private navCtrl: NavController,
		private navParams: NavParams,
		private signaling: SignalingSocketIoProvider,
		private toastCtrl: ToastController,
		private viewCtrl: ViewController
	) {
		console.group('[LoginPage.constructor()]', navParams)
		//this.makeSession = this.navParams.get("makeSession");
		//se true chiede alle altre sessioni di questo utente di fare logout

		//opzione login mutuamente esclusivo
		switch(devices.actualType) {
			case DeviceType.BROWSER:
				this.isExclusiveLogin = true
				break
			case DeviceType.DASHBOARD://logout temporaneo no incoming call
				this.isExclusiveLogin = false
				break
			case DeviceType.INTERCOM://logout temporaneo no incoming call
				console.debug('Dispositivo corrente citofono (INTERCOM), login esclusivo disabilitato')
				this.isExclusiveLogin = false
				break
			case DeviceType.SMARTPHONE:
				this.isExclusiveLogin = true
				break
		}

		this.next = this.navParams.get("next")
		this.nextCall = this.navParams.get('nextCall')
		this.nextNavParams = this.navParams.get("nextNavParams")
		this.nextGuard = this.navParams.get("nextGuard")//funzione ():boolean che verifica se l'utente ha i permessi per proseguire a next o nextCall
		this.nextPush = this.navParams.get("nextPush") ? true : false//Se true e ha next, next va in push, altrimenti va in root
		this.nextPop = this.navParams.get("nextPop") ? true : false//Se true e non ha next esegue solo pop

		this.roles = this.navParams.get("roles")//ruoli richiesti per potersi autenticare, altrimenti esegue logout

		this.isTypeForced = this.navParams.get("isTypeForced") ? true : false

		this.type = this.navParams.get("type")
		if(this.type) {
			console.debug('Modo di autenticazione specificato: ' + this.type)
		} else {
			console.debug('Nessun modo di autenticazione specificato, imposto il default per questo dispositivo..')
			this.type = this.devices.getDefaultAuthType()
		}
		//this.oneTime=navParams.get("oneTime")?true:false;
		console.groupEnd()
	}

	public login() {
		this.resetPopTimeout()

		this.loading = this.loadingCtrl.create({
			content: 'Autenticazione in corso...',
			dismissOnPageChange: false,
			duration: ConfigProvider.TIMEOUT_LOGIN * 1000,
		})
		this.loading.present()

		let self = this
		let timedOut = false

		//JS è monothread, quindi O esegue prima questo O esegue prima il login, non li esegue in parallelo
		let timeout = setTimeout(() => {
			if(!self.auth.isAuth) {//non ha ancora fatto login
				console.debug('[AuthProvider.login().timeout] Timeout di login, rimuovo il loader')
				timedOut = true

				//self.loading.dismiss(); NON serve: ha il suo timeout pari a questo

				let toast = self.toastCtrl.create({
					message: 'Timeout durante l\'autenticazione',
					position: 'middle',
					cssClass: 'danger',
					duration: 3000
				})
				toast.present()
				self.navCtrl.pop()
				self.changeDetector.detectChanges()
			}
		}, ConfigProvider.TIMEOUT_LOGIN * 1000)

		this.auth.login(this.type, this.credentials.identifier, this.credentials.secret, this.remember).then(user => {
			//JS è monothread, quindi O esegue prima questo O esegue prima il timeout, non li esegue in parallelo
			clearTimeout(timeout)

			//se troppo tardi annulla il login e termina, è già uscito dalla pagina con feedback al timeout
			if(timedOut) {
				self.auth.logout()
				self.changeDetector.detectChanges()
				return
			}

			if(user) {
				console.debug('[LoginPage.login().next()] Utente trovato: ', user)

				if(self.nextGuard && !self.nextGuard(self.auth)) {
					let toast = self.toastCtrl.create({
						message: 'Il tuo account non ha i permessi adeguati',
						position: 'middle',
						cssClass: 'danger',
						duration: 3000
					})
					toast.present()
					self.navCtrl.pop()
					self.changeDetector.detectChanges()
					return
				}


				if(self.isExclusiveLogin) {
					//richiede il logout delle altre sessioni dello stesso utente
					console.debug('[LoginPage.login().next()] Login esclusivo, disconnetto gli altri dispositivi..')
					self.signaling.sendLogoutRequest(user.id, DeviceProvider.identifier)
				}


				let toast = self.toastCtrl.create({
					message: 'Accesso come ' + self.auth.user.name + ' ' + self.auth.user.surname,
					position: 'middle',
					duration: 3000
				})
				toast.present()

				if(self.nextCall) {
					console.debug('[LoginPage.login.then()] Trovata una funzione da invocare al login, la invoco..')
					self.nextCall()
				}

				if(self.next) {
					console.debug('[LoginPage.login.then()] Pagina da impostare successivamente al login:', self.next)
					if(self.nextPush) {
						console.debug('[LoginPage.login.then()] Pagina successiva aggiunta in modo push, sostituisco la pagina attuale con la prossima..')
						/*
						//XXX  QUESTA SOLUZIONE ARRIVA ALLA BACHECA, CHE ESEGUE LOGOUT AUTOMATICAMENTE E NON VA BENE
						self.navCtrl.pop({ animate: false });
						self.navCtrl.push(self.next, self.nextNavParams)
						*/
						//2022 ora impila prima questo e poi la dashboard, percui non è più possibile spilare
						//XXX Tappullo: attendo un timeout e poi eseguo
						setTimeout(() => {
							self.navCtrl.push(self.next, self.nextNavParams).then(function() {
								let index = self.viewCtrl.index
								console.debug('[LoginPage.auth.login.then()] Prossima pagina impilata, rimuovo la pagina attuale di login dalla seconda posizione..', self.navCtrl, self.viewCtrl)
								//XXX con la nuova modalità non funziona se spilo
								//self.navCtrl.remove(index)
							})
						}, 1000)
					} else {
						console.debug('[LoginPage.auth.login.then()] Pagina successiva da impostare come root')
						self.navCtrl.setRoot(self.next, self.nextNavParams)
					}
				} else {
					let root = self.flavour.actualRoot
					console.debug('[LoginPage.auth.login.then()] Imposto la root successiva al login:', root)
					self.navCtrl.setRoot(root)
				}

				/*
				if(this.oneTime){
				this.auth.logout();	}
				*/
			} else {
				console.debug('[LoginPage.login()] Autenticazione fallita')

				switch(self.type) {
					case AccountType.PIN:
						self.credentials.identifier = ''
						break
					case AccountType.EMAIL_PASSWORD:
						self.credentials.secret = ''
						break
				}
				self.showError("Credenziali non valide")
			}

			console.debug('[LoginPage.auth.login.then()] Rimuovo il loader..')
			self.loading.dismiss()
			self.changeDetector.detectChanges()
		}).catch(error => {
			clearTimeout(timeout)
			console.warn('Errore autenticando l\'utente', error)
			self.showError("Errore durante l'autenticazione: " + error)

			console.debug('[LoginPage.auth.login.catch()] Rimuovo il loader..')
			self.loading.dismiss()
			self.changeDetector.detectChanges()
		})
	}

	public appendPin(digit) {
		this.resetPopTimeout()
		if(this.credentials.identifier === null) {
			this.credentials.identifier = ''
		}
		this.credentials.identifier += digit
		this.changeDetector.detectChanges()
	}

	public backspacePin() {
		this.resetPopTimeout()
		if(this.credentials.identifier === null || this.credentials.identifier.length < 1) {
			return
		}
		this.credentials.identifier = this.credentials.identifier.substring(0, this.credentials.identifier.length - 1)
		this.changeDetector.detectChanges()
	}

	ionViewWillEnter() {
		console.debug('[LoginPage.ionViewWillEnter()]', this.navCtrl)
		//si assicura di svuotare valori precedenti
		this.reset()
	}

	ionViewWillLeave() {
		if(this.popTimeout) {
			clearTimeout(this.popTimeout)
			console.debug('[LoginPage.ionViewWillLeave()] Eliminato il timeout di interazione')
		}
	}

	public reset() {
		this.resetPopTimeout()
		this.credentials = {
			identifier: '',
			secret: ''
		}
		this.changeDetector.detectChanges()
	}


	/**
	Posticipa l'eventuale ritorno alla root dopo 60 secondi
	*/
	private resetPopTimeout() {
		console.group('[LoginPage.resetPopTimeout()]')
		if(this.popTimeout) {
			clearTimeout(this.popTimeout)
			console.debug('Interazione utente, eliminato il timeout di POP')
		}


		this.popTimeout = setTimeout(() => {
			console.debug('[LoginPage.resetPopTimeout()] Timeout')
			let root = this.flavour.actualRoot
			console.info('[Login.popTimeout()] Reset della root per la configurazione attuale: ', root)

			if(root != LoginPage) {
				let self = this
				console.debug('Timeout interazioni utente con root diversa da login: Ritorno alla root:', root)
				self.navCtrl.setRoot(root)
			}
			console.groupEnd()
		}, ConfigProvider.TIMEOUT_INTERACTION * 1000)
		console.groupEnd()
	}

	private showError(text) {
		let errorAlert = this.alertCtrl.create({
			title: 'Errore',
			subTitle: text,
			buttons: ['OK']
		})
		errorAlert.present()
	}

	public switchType(type: AccountType) {
		this.resetPopTimeout()

		this.type = type
		this.reset()
	}
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts